import gsap from "gsap";

import ScrollTrigger from "gsap/dist/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

import NiceSelect from "nice-select2";

document.querySelectorAll(".js-contact").forEach((el) => {
	el.querySelectorAll(".wpcf7-select").forEach((select) => {
		select.style.border = "0";

		new NiceSelect(select, {
			placeholder: "&nbsp;",
		});
	});

	const wpcf7wrapper = el.querySelector(".wpcf7");

	const success_view = el.querySelector(".js-success-view");

	const success_lines = el.querySelectorAll(".js-sucess-line");

	el.querySelectorAll([".wpcf7-text", ".wpcf7-textarea"]).forEach(
		(formItem) => {
			let placeholder = formItem.getAttribute("placeholder");

			formItem.removeAttribute("placeholder");

			formItem.oninput = () => {
				formItem.classList.toggle("has-value", formItem.value.trim() !== "");
			};

			const label = document.createElement("span");

			label.classList.add("input-label");
			label.textContent = placeholder;

			formItem.parentNode.insertBefore(label, formItem.nextSibling);
		},
	);

	el.querySelectorAll(".wpcf7-select").forEach((select) => {
		select.addEventListener("change", (e) => {
			// console.log("select changed: ", select.value);
			select.classList.add("has-value");
		});
	});

	const formSentAnimation = () => {
		gsap.to(wpcf7wrapper, {
			opacity: 0,
		});

		success_view.classList.remove("hidden");

		gsap.fromTo(
			success_lines,
			{
				y: 10,
				opacity: 0,
			},
			{
				y: 0,
				opacity: 1,
				stagger: 0.1,
			},
		);
	};

	window.formSentAnimation = formSentAnimation;

	wpcf7wrapper.addEventListener("wpcf7mailsent", () => {
		formSentAnimation();
	});

	// append custom icons

	const selectIcon = el.querySelector(".icon-dropdown");

	const customCheckbox = el.querySelector(".checkbox");

	const selectAdditionalLabel = document.createElement("span");

	selectAdditionalLabel.classList.add("input-label");

	selectAdditionalLabel.innerText = "Subject*";

	el.querySelectorAll(".wpcf7-select").forEach((select) => {
		select.parentNode.insertBefore(selectIcon, select.nextSibling);

		select.parentNode.insertBefore(selectAdditionalLabel, select.nextSibling);
	});

	el.querySelectorAll("input[type=checkbox]").forEach((checkbox) => {
		checkbox.parentNode.insertBefore(customCheckbox, checkbox.nextSibling);
	});

	// animation

	const animate_els = el.querySelectorAll(".js-animate");

	gsap.fromTo(
		animate_els,
		{
			opacity: 0,
			y: "0.625rem",
		},
		{
			opacity: 1,
			y: 0,
			delay: 0.3,
			stagger: 0.1,
		},
	);

	const bg = el.querySelector(".js-bg");

	const form_container = el.querySelector(".form-container");

	if (bg) {
		ScrollTrigger.create({
			trigger: form_container,
			start: "top bottom",
			scrub: true,
			end: "bottom top",
			animation: gsap.fromTo(bg, { y: "-2rem" }, { y: "2rem" }),
		});
	}
});
